/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Grid, Table, Dropdown, Segment, Message } from 'semantic-ui-react';
import Section from '../../components/Section';
import { Policy } from '../../components/sections';
import { autoIdCardsSelector } from '../../selectors';
import { policyIcon } from '../../helpers/policy';
import moment from 'moment';
import { printUrl } from '../../helpers/policy';

const AutoIdCardsSection = ({ policies, mobileShow, onClick }) => {
	var [selectedPolicy, setSelectedPolicy] = useState();

	var onListItemClick = useCallback((_, { data }) => {
		setSelectedPolicy(data);
	}, []);

	useEffect(() => {
		if (!selectedPolicy && policies.length > 0) {
			setSelectedPolicy(policies[0]);
		}
	}, [policies, selectedPolicy]);

	const onPolicyDropdownChange = useCallback(
		(_, { value }) => {
			const policy = policies.find((p) => p.policyNumber === value);
			setSelectedPolicy(policy);
		},
		[policies]
	);

	const policyOptions = useMemo(
		() =>
			policies.map((policy) => {
				return { text: `${policy.nickname} (${policy.policyNumber})`, value: policy.policyNumber, data: policy };
			}),
		[policies]
	);

	return (
		<Section name='autoidcards' title='Auto ID Cards' color='yellowish' mobileShow={mobileShow}>
			{policies.length > 0 ? (
				<Grid>
					<Grid.Column width={4} className='tablet only computer only'>
						<Policy.List>
							{policies.map((policy, i) => {
								return <Policy.ListItem key={i} onClick={onListItemClick} icon={policyIcon(policy.policyNumber)} nickName={policy.nickname} policyNumber={policy.policyNumber} data={policy} active={selectedPolicy && selectedPolicy.policyNumber === policy.policyNumber} effective={policy.effective} expiration={policy.expiration} type={policy.type} status={policy.statusText} />;
							})}
						</Policy.List>
					</Grid.Column>
					<Grid.Column className='left divider' mobile={16} computer={12} tablet={12}>
						<Dropdown className='mobile only' value={selectedPolicy && selectedPolicy.policyNumber} fluid selection options={policyOptions} onChange={onPolicyDropdownChange} />
						{selectedPolicy && selectedPolicy.cards.length > 0 && (
							<Table celled unstackable>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>Date</Table.HeaderCell>
										<Table.HeaderCell>Vehicle</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{selectedPolicy &&
										selectedPolicy.cards.map((d, i) => {
											return (
												<Table.Row key={i}>
													<Table.Cell width={2}>{moment(d.printDate).format('MM/DD/YYYY')}</Table.Cell>
													<Table.Cell width={12}>
														<a href={printUrl(d.printUrl)} target='_blank' rel='noopener noreferrer'>
															{d.year} {d.make} {d.model}
														</a>
													</Table.Cell>
												</Table.Row>
											);
										})}
								</Table.Body>
							</Table>
						)}

						{selectedPolicy && selectedPolicy.cards.length === 0 && (
							<Message>
								<div>Auto ID cards for Garage (GAR) and Commercial Package (CPP) policies can be found in the <a href={`/${selectedPolicy.policyNumber}/documents`} onClick={onClick}>Documents</a> tab within the Policies section.</div>
								<center>Questions? Please contact <a href='/help' onClick={onClick}>Customer Service</a> at 800.477.1660.</center>
							</Message>
						)}
					</Grid.Column>
				</Grid>
			) : (
				<Segment style={{ textAlign: 'center' }}>
					<h2>No Auto ID Cards</h2>
				</Segment>
			)}
		</Section>
	);
};

AutoIdCardsSection.propTypes = {};

const mapStateToProps = (state, ownProps) => {
	return {
		...autoIdCardsSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: { },
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoIdCardsSection);
